import React from 'react';

import { Link } from '@edx/components/link';
import { IconPlaySolid } from '@edx/components/icons';

import { PathEntryProps } from './';
import { Body, Caption, Title } from '@edx/components/typography';

type Props = {
  items: PathEntryProps[];
};

export const PathEntries: React.FC<Props> = ({ items }) => (
  <ul className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
    {items.map(({ name, tagline, img, resourcePath, videosCount }) => (
      <li
        key={resourcePath}
        className="relative group overflow-hidden hover:bg-gray-600 hover:bg-opacity-10 transition duration-150"
      >
        <Link href={resourcePath}>
          <div className="relative group">
            <div className="relative aspect-ratio-21/9 md:aspect-ratio-square">
              <picture>
                <source media="(min-width: 769px)" srcSet={img.large} />
                <img src={img.medium} alt={name} className="absolute" />
              </picture>
            </div>

            <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 group-hover:bg-opacity-0 transition duration-150">
              <div className="p-2 bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 ease transform translate-y-3 group-hover:translate-y-0">
                <IconPlaySolid className="text-primary-500 w-6" />
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col font-body text-gray-500 space-y-2 p-2">
            <div className="flex justify-between">
              <div className="flex flex-col space-y-1">
                <Title tag="header" className=" md:text-large text-gray-300 leading-tight">
                  {name}
                </Title>

                <Caption tag="span" variant="semibold" className="leading-relaxed">
                  {videosCount} Videos
                </Caption>
              </div>
            </div>

            {tagline && <Body>{tagline}</Body>}
          </div>
        </Link>
      </li>
    ))}
  </ul>
);
